import { createServiceFactory } from '@/services/factory'
import { createHttpAssistantWorkService } from './assistantWork.http'
import { createMockAssistantWorkService } from './assistantWork.mock'

export type { AssistantWorkService } from './assistantWork.service'

export const getAssistantWorkService = createServiceFactory(
  'assessments',
  createMockAssistantWorkService,
  createHttpAssistantWorkService,
)
